import { Button, Col, Row, Space } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { AutoCompleteInput } from "./features/autocomplete/AutoCompleteInput";
import { LatLngInput } from "./features/coordenadas/LatLngInput";
import { MarkerDraggable } from "./features/marker/MarkerDraggable";
import { BuscadorLugares } from "./features/buscador/BuscadorLugares";
import { DireccionGeocoded } from "./features/geocoding/DireccionGeocoded";
import { WhatsAppButton } from "./features/whatsapp/WhatsAppButton";
import { TalleresMarkers } from "./features/talleres/TalleresMarkers";
import { TalleresButton } from "./features/talleres/TalleresButton";

export const MapaContent = ({
  latLng,
  setLatLng,
  onConfirmar,
  direccionActual,
  onDireccionInterna,
  onLoadingDireccion,
  loadingDireccion,
  whatsAppProps,
  talleresProps,
}) => {
  return (
    <>
      <Space direction="vertical" size="middle" style={{ width: "100%", marginBottom: 12 }}>
        <AutoCompleteInput setLatLng={setLatLng} />
        <LatLngInput latLng={latLng} setLatLng={setLatLng} />
      </Space>

      <MarkerDraggable latLng={latLng} setLatLng={setLatLng} />
      <BuscadorLugares setLatLng={setLatLng} />
      {talleresProps?.talleres && <TalleresMarkers talleres={talleresProps.talleres} setLatLng={setLatLng} />}
      <DireccionGeocoded latLng={latLng} onDireccionChange={onDireccionInterna} onLoadingChange={onLoadingDireccion} />

      <div style={{ marginTop: 16 }}>
        <Row gutter={8}>
          {whatsAppProps && (
            <Col span={12}>
              <WhatsAppButton {...whatsAppProps} />
            </Col>
          )}
          {talleresProps && (
            <Col span={12}>
              <TalleresButton
                talleres={talleresProps.talleresData}
                activos={talleresProps.activos}
                onTalleresLoad={talleresProps.onTalleresLoad}
                onToggle={talleresProps.onToggle}
              />
            </Col>
          )}
          <Col span={whatsAppProps || talleresProps ? 12 : 24}>
            <Button
              type="primary"
              size="large"
              icon={<CheckOutlined />}
              block
              loading={loadingDireccion}
              disabled={!direccionActual?.direccionCompleta || loadingDireccion}
              onClick={() => onConfirmar(direccionActual)}
            >
              Confirmar Ubicación
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};
